export default "__VITE_ASSET__dlcyVZZa__"